import { render, staticRenderFns } from "./index-shipto.vue?vue&type=template&id=a879270c&scoped=true&"
import script from "./index-shipto.vue?vue&type=script&lang=js&"
export * from "./index-shipto.vue?vue&type=script&lang=js&"
import style0 from "./index-shipto.vue?vue&type=style&index=0&id=a879270c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a879270c",
  null
  
)

export default component.exports